import { useState, useRef } from "react";
import { hexToHSL } from "../Colors/Colors_Utils";
import { PositionItemsInOrder } from "../../../refractCommon/miro/PositionItemsInOrder";

const { board } = window.miro;

export default function SortByColor({ boardSelection }) {
  const [redLeft, setRedLeft] = useState(true);
  const [redRight, setRedRight] = useState(false);
  const [colorStartPoint, setColorStartPoint] = useState(0);
  const [boardSelectedColor, setBoardSelectedColor] = useState("#FFFFF");
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const content = useRef(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content?.current?.scrollHeight}px`);
  }

  let sortByColorTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-sticky-bulk cs1"></div>
      <div className="m2 icon icon-rectangle cs2"></div>
      <div className="m2 icon icon-card cs3"></div>
      <div className="m2 icon icon-text cs4"></div>
      <div className="m2 icon icon-frame cs5"></div>
    </div>
  );

  function runSelectItemsForSortByColor(selection) {
    let filteredSelection = selection.filter(
      (item) =>
        (item.type === "sticky_note" && item.parentId === null) ||
        (item.type === "text" && item.parentId === null) ||
        (item.type === "card" && item.parentId === null) ||
        (item.type === "shape" && item.parentId === null) ||
        (item.type === "frame" && item.childrenIds.length === 0)
    );
    return filteredSelection;
  }
  // ------------------------------------

  async function runSortByColor() {
    let filteredSelection = runSelectItemsForSortByColor(
      await board.getSelection()
    );
    // get each item's hex (frame.style.fillColor, card.style.cardTheme, shape.style.fillColor, sticky.style.fillColor, text.style.fillColor )
    let newItemsForUpdate = [];
    filteredSelection.forEach((item) => {
      let sortNumber = hexToHSL(getHexColorFromOneItem(item)).h;

      if (sortNumber < colorStartPoint) {
        sortNumber += 360;
      }

      newItemsForUpdate.push({
        sortNumber: sortNumber,
        item: item,
      });
    });

    if (redLeft) {
      newItemsForUpdate.sort((a, b) => a.sortNumber - b.sortNumber);
    } else {
      newItemsForUpdate.sort((a, b) => b.sortNumber - a.sortNumber);
    }

    await PositionItemsInOrder(newItemsForUpdate.map((i) => i.item));
  }

  function getHexColorFromOneItem(item) {
    let colorHex;
    if (item.type === "card") {
      colorHex = item.style.cardTheme;
    } else if (item.type === "sticky_note") {
      colorHex = stickyColorDict[item.style.fillColor];
    } else {
      colorHex = item.style.fillColor;
    }
    return colorHex;
  }

  async function selectColorFromBoard() {
    if (boardSelection.length === 1) {
      let selection = await board.getSelection();
      let filteredSelection = await runSelectItemsForSortByColor(selection);
      if (filteredSelection.length === 1) {
        let hexColor = getHexColorFromOneItem(filteredSelection[0]);
        setBoardSelectedColor(hexColor);
        let HSLColor = hexToHSL(hexColor);
        // WE need to send back HSL as an object...
        setColorStartPoint(HSLColor.h);
      }
    }
  }

  return (
    <div id="sort-by-color-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="sort-by-color-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 mb-0 icon m2 icon-pen"></div>
        <div className="cs2 ce11 h3 mb-0">Color</div>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
      </div>

      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          {/* <div className="cs1 ce12 p-medium mt-0">
            Fill a selection with chosen text, or clear that selection of all
            text.
          </div> */}
          <div
            id="sort-by-color-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on <b>many:</b>
            </p>

            {sortByColorTypeIcons}
          </div>

          <div className="cs1 ce12 grid">
            <div className="cs1 ce3 grid">
              <div className="cs1 ce12 p-medium">Direction</div>
              <label className="radiobutton cs1 ce12 mt-0 mb-0">
                <input
                  type="radio"
                  tabIndex="0"
                  defaultValue="0"
                  name="Red to Violet"
                  checked={redLeft}
                  onChange={() => {
                    setRedLeft(!redLeft);
                    setRedRight(redLeft);
                  }}
                />
                <span>🡆</span>
              </label>
              <label className="radiobutton cs1 ce12 mt-0 mb-0 align-left">
                <input
                  type="radio"
                  tabIndex="0"
                  defaultValue="0"
                  name="Violet to Red"
                  checked={redRight}
                  onChange={() => {
                    setRedRight(!redRight);
                    setRedLeft(redRight);
                  }}
                />
                <span>🡄</span>
              </label>
            </div>
            <div className="cs4 ce12 grid">
              <div className="cs1 ce12 p-medium">Start Color</div>
              <div className="slidecontainer mt--6 mb-32 cs1 ce12">
                <input
                  type="range"
                  min="0"
                  max="360"
                  value={colorStartPoint}
                  className="spectrum-slider"
                  onChange={(e) => {
                    setColorStartPoint(e.target.value);
                  }}
                  // onMouseUp={() => {}}
                  id="myParaRange"
                />
              </div>
              {/* <button
            type="button"
            style={{ backgroundColor: { boardSelectedColor } + " !important" }}
            onClick={selectColorFromBoard}
            className="button button-secondary-border button-small cs1 ce12"></button> */}
            </div>
          </div>

          <div
            type="button"
            className="button button-primary button-small cs1 ce12 mt-8 fix-stupid-button"
            onClick={runSortByColor}>
            Sort
          </div>
        </div>
      </div>
    </div>
  );
}

const stickyColorDict = {
  gray: "#F5F6F8",
  light_yellow: "#FFF9B1",
  yellow: "#F5D128",
  orange: "#FF9D48",
  light_green: "#D5F692",
  green: "#C9DF56",
  dark_green: "#93D275",
  cyan: "#67C6C0",
  light_pink: "#FFCEE0",
  pink: "#EA94BB",
  violet: "#BE88C7",
  red: "#F16C7F",
  light_blue: "#A6CCF5",
  blue: "#6CD8FA",
  dark_blue: "#7B92FF",
  black: "#000000",
};
